import { Injectable, inject } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { TextDeliverableService } from '../shared/text-deliverable/text-deliverable.service';
import { TitleComponent } from './title.component';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private readonly textDeliverableService = inject(TextDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.textDeliverableService.getConfig({
      component: TitleComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.titleDeliverable.title',
      deliverableType: EDeliverableType.title,
    });
  }
}
